export interface Contest {
    category: string;
    end_at: string;
    id: number;
    name: string;
    slug: string;
    start_at: string;
    user_state: UserStates | null;
    is_participant: boolean;
}

export interface SbContest extends Contest {
    icon: string;
    subText: string;
    type: string;
}

export interface ContestSubText {
    text: string;
    type: "danger" | "info" | "success";
}

export enum UserStates {
    NOT_BET_TODAY = "not-bet-today", //Uživatel dnes ještě nevsadil a maraton již začal nebo uživatel dnes nemá natipováno v tipovačce
    BET_TODAY = "bet-today", //Uživatel dnes má již vsazeno a maraton již začal nebo uživatel má dnes natipováno v tipovačce.
    FAILED = "failed", // Uživatel vypadnul z maratonu
    NOT_LOGIN = "not-login", // Uživatel není přihlášen do soutěže
    LOGIN = "login", // Uživatel je přihlášen do soutěže
}
